module.exports = __webpack_public_path__ + "8d4dd845ca453782.png";